var _defs, _polygon, _polyline, _polygon2, _polygon3, _polygon4, _polygon5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBgShipTransporter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 706.65 706.65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#3a2834;}.cls-2{fill:#594a55;}.cls-3{fill:#33222e;}.cls-4{fill:aqua;}.cls-5{fill:#4c3547;}"))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "123.9 287.9 148.18 257.9 523.92 330.76 611.07 430.77 95.58 431.23 123.9 287.9"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "123.9 287.9 148.18 247.9 461.31 298.29 523.92 330.76"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "106.75 443.63 596.78 443.63 611.07 430.77 95.32 430.77 106.75 443.63"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "473.88 458.75 584.47 458.75 597.04 444.09 461.31 444.09 473.88 458.75"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "120.96 458.45 231.56 458.45 244.12 443.79 108.4 443.79 120.96 458.45"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "207.01 431.23 611.32 431.23 524.17 331.23 418.45 319.8 207.01 431.23"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgShipTransporter);
export default __webpack_public_path__ + "static/media/bg-ship-transporter.f77734c1bcb900ed4198467d86c920f2.svg";
export { ForwardRef as ReactComponent };